(function($) {
  const current = window.location.href;
  const mobileBottomMenu = jQuery('.mobileBottomMenuWrapper');
  jQuery('.mobileBottomMenu li a').each(function() {
    const $this = $(this);
    // if the current path is like this link, make it active
    console.log(current);
    if ($this.attr('href') === current) {
      $this.parent().addClass('active');
    }
  });

  $(window).scroll(function() {
    const scrollDistance = $(window).scrollTop();
    if (scrollDistance > 500) {
      mobileBottomMenu.addClass('active');
    } else {
      mobileBottomMenu.removeClass('active');
    }
  });

})(jQuery);
